import LanguageDetect from './language-detect.js'

export { LanguageDetect }
